import type { LeadId } from "@whitehaven/contracts";
import { normalizePortalPathname } from "../../usePortalLocation";

const ADMIN_CRM_PATH = "/admin/crm";
const ADMIN_LEAD_LIST_PATH = "/admin/crm/leads";
const ADMIN_LEAD_PIPELINE_PATH = "/admin/crm/pipeline";
const LEAD_ID_PATH_PATTERN = /^[A-Za-z0-9_-]{8,128}$/;

export type AdminCrmRouteMatch =
  | { readonly kind: "lead-list" }
  | { readonly kind: "lead-pipeline" }
  | { readonly kind: "lead-detail"; readonly leadId: LeadId }
  | { readonly kind: "invalid" }
  | null;

export function isSafeLeadIdPathSegment(value: string): value is LeadId {
  return LEAD_ID_PATH_PATTERN.test(value);
}

export function createAdminLeadDetailHref(leadId: LeadId): string | null {
  return isSafeLeadIdPathSegment(leadId)
    ? `${ADMIN_LEAD_LIST_PATH}/${leadId}`
    : null;
}

export function resolveAdminCrmRoute(pathname: string): AdminCrmRouteMatch {
  const normalizedPath = normalizePortalPathname(pathname);

  if (
    normalizedPath === ADMIN_CRM_PATH ||
    normalizedPath === ADMIN_LEAD_LIST_PATH
  ) {
    return { kind: "lead-list" };
  }

  if (normalizedPath === ADMIN_LEAD_PIPELINE_PATH) {
    return { kind: "lead-pipeline" };
  }

  const detailPrefix = `${ADMIN_LEAD_LIST_PATH}/`;
  if (normalizedPath.startsWith(detailPrefix)) {
    const leadId = normalizedPath.slice(detailPrefix.length);
    return isSafeLeadIdPathSegment(leadId)
      ? { kind: "lead-detail", leadId }
      : { kind: "invalid" };
  }

  return null;
}
